const customerOrderCardTemplate = document.querySelector('#order-card-template');

if (!customerOrderCardTemplate) return;

function getOrderCardDate(orderCard) {
  const orderCardDateEl = orderCard.querySelector('[data-order-card-date] .content');
  const orderDatePreFormat = orderCardDateEl?.textContent;

  let orderDate;

  const [day, month, year] = orderDatePreFormat.split('/');

  if (year) orderDate = new Date(`${year}-${month}-${day}`);

  return orderDate;
}

async function getTransactions() {
  const body = document.querySelector('body');
  const isLoggedIn = body.dataset.loggedIn === 'true';

  if (!isLoggedIn) return;

  const member = await Shopify.functions.getMember();

  if (member) {
    const transactions = await Shopify.functions.getTransactions();
    return transactions;
  }

  return null;
}

function renderInstoreOrder({ order, orderCard, orderCardsContainer }) {
  const orderCardClone = customerOrderCardTemplate.content.cloneNode(true);
  const orderId = (order.number || '').replace(/^0+/, '');
  const orderTotal = Number(order.total) || 0;
  const orderDate = new Date(order.purchasedAt).toLocaleDateString('da-DK', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }).replace(/\./g, "/");
  const orderItemsCount = order.itemCount ?? order.items?.length ?? 0;

  const cardIdEl = orderCardClone.querySelector('#order-card-id .content');
  cardIdEl.textContent = orderId;

  const cardDateEl = orderCardClone.querySelector('#order-card-date .content');
  cardDateEl.textContent = orderDate;

  const cardTotalEl = orderCardClone.querySelector('#order-card-price .content');
  cardTotalEl.textContent = orderTotal.toFixed(2) + ' kr';

  const cardItemsCountEl = orderCardClone.querySelector('#order-card-quantity .content');
  cardItemsCountEl.textContent = orderItemsCount;

  const cardProductListEl = orderCardClone.querySelector('#order-card-product-list');
  const cardProductTitle = orderCardClone.querySelector('.product-title');

  (order.items || []).forEach((item, i) => {
    const title = item.name;
    const quantity = item.quantity;
    const price = Number(item.price) || 0;
    const productTitleEl = document.createElement('div');
    productTitleEl.classList.add('product-title', 'h9-bold', 'product-title');
    const multiplyEl = document.createElement('span');
    multiplyEl.classList.add('lowercase');
    multiplyEl.textContent = 'x';
    productTitleEl.append(`${title} `, multiplyEl, ` ${quantity} — ${price.toFixed(2)} kr`);
    cardProductListEl.appendChild(productTitleEl);
  });


  // append
  if (orderCard) orderCardsContainer.insertBefore(orderCardClone, orderCard);
  else orderCardsContainer.appendChild(orderCardClone);
}

function renderInstoreOrders({ inStoreOrders }) {
  const orderCardsContainer = document.querySelector('[data-customer-orders]');
  const existingOrderCards = [...document.querySelectorAll('[data-order-card-container]')];

  inStoreOrders.forEach(order => {
    const instorePurchasedAt = new Date(order.purchasedAt);
    let inserted = false;

    existingOrderCards.forEach(orderCard => {
      const existingOrderPurchaseDate = getOrderCardDate(orderCard);

      if (existingOrderPurchaseDate && !inserted) {
        // When inStorePurchase is newer add it before the existing order
        if (instorePurchasedAt > existingOrderPurchaseDate) {
          renderInstoreOrder({ order, orderCard, orderCardsContainer });
          inserted = true;
        }
      }
    });

    // If the order is older than all existing orders, add it at the end
    if (!inserted) renderInstoreOrder({ order, orderCardsContainer });
  });

  if (inStoreOrders?.length) {
    const instoreOrdersTitle = document.querySelector('.instore-orders-title');
    instoreOrdersTitle.classList.remove('hidden');
  }
}

async function displayInstoreOrders() {
  const customerTransactions = await getTransactions();

  // Web orders are already listed by Shopify, so only in-store ones are added.
  const allTransactions = customerTransactions?.items || [];
  const inStoreOrders = allTransactions.filter(item => item.isInStore);

  inStoreOrders.sort((a, b) => new Date(b.purchasedAt) - new Date(a.purchasedAt));

  if (!inStoreOrders?.length) return; 

  renderInstoreOrders({ inStoreOrders });
}

displayInstoreOrders();

